module.exports = __webpack_public_path__ + "static/assets/844b5a038fdb7a5d2455040a0c81f0ad.png";